<template>
  <div id="page-appointment">
  <div class="row">
    <div class="col-12">
      <router-link to="/dashboard" tag="button" class="back-home">Back to Home</router-link>
      <card>
        <div slot="raw-content" class="table-responsive">
          <div class="row" id="top-tool-bar">
            <div class="col-6">
              
            </div>
            <div class="col-6">
              <p-button type="info" if=round @click.native.prevent="modalAddAppointment" id="add-appointment">
                 Add Appointment
              </p-button>
            </div>
          </div>
          <div class="row" id="top-tool-bar">
            <div class="col-6">
              <select @change="SelectView" v-model="select_view" id="select-view">
                  <option value="">Select View</option>
                  <option value="list">List</option>
                  <option value="calendar">Calendar</option>
               </select>
               <date-picker v-model="date_range" range v-if='view_list && select_view!=""'></date-picker>
              <p-button type="info" round @click.native.prevent="generate" id="generate-appoint" v-if='view_list && select_view!=""'>Generate</p-button>  
            </div>
          </div>
          <loader v-if="loader"/>
          <FullCalendar ref="cc" :options='calendarOptions' id="fullcalendar" v-if="calendar_list" /> 
          <table class="table table-striped" id="appoint-tbl" v-if='view_list && select_view!=""'>
   <thead>
      <th>First Name</th>
      <th>Last Name</th>
      <th>Contact Number</th>
      <th>Date</th>
      <th>Time</th>
      <th>Services</th>
      <th>Branch</th>
      <th>Status</th>
      <th>Action</th>
   </thead>
   <tbody v-if="appointments.total > 0">
                                    <tr v-for="(appointment,index) in appointments.data" :key="index">
                                        <td>{{ appointment.first_name }}</td>
                                        <td>{{ appointment.last_name }}</td>
                                        <td>{{ appointment.contact_number }}</td>
                                        <td>{{ appointment.date }}</td>
                                        <td>{{ appointment.time }}</td>
                                        <td>{{ appointment.formated_service }}</td>
                                        <td>{{ appointment.branch_id === 1 ? 'Gaerlan' : appointment.branch_id === 2 ? 'Dolores' : 'Unknown' }}</td>
                                        <td>{{ appointment.status }}</td>
                                        <td class="action">
                                             <p-button type="info" round @click.native.prevent="moveListToClient(appointment)" v-if="appointment.client_exist==0">
                                                <span class="ti-arrow-right"></span>
                                              </p-button>
                                              <p-button type="info" round @click.native.prevent="modalEditAppointment(appointment)">
                                                <span class="ti-pencil"></span>
                                              </p-button>
                                              <p-button type="info" round @click.native.prevent="deleteAppointment(appointment.id)">
                                                  <span class="ti-trash"></span>
                                              </p-button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr>
                                        <td align="center" colspan="7" id="no-record">No record found.</td>
                                    </tr>
   </tbody>
   
</table>
        <paginate
            :page-count="total_page"
            :page-range="1"
            :margin-pages="2"
            :click-handler="clickCallback"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :container-class="'pagination'"
            :page-class="'page-item'"
            v-if='appointments.total > 0 &&  !calendar_list && select_view!=""'
            >
          </paginate>
        </div>
      </card>
    </div>
  </div>

    <Modal :showModal="modalVisible" :title="modal_title" @close="closeModalAppointment" id="addAppointmentForm">
      <loader v-if="loader_save"/> 
      <select @change="selectClient($event)" class="select-client" v-model="info.client_type">
          <option value="">Select Client</option>
          <option value="new">New Client</option>
          <option value="existing">Existing Client</option>
      </select>
          <div v-show="view_existing">
          <v-autocomplete :items="items" v-model="input_name" :get-label="getLabel" :component-item='template' @update-items="updateItems" placeholder="Enter Name" class="autocomplete">
          </v-autocomplete>     
          </div> 
          <div v-show="view_new">
              <fg-input
                        v-model="info.first_name"
                        label="First Name"
                        placeholder="First Name"
                      />
              <fg-input
                        v-model="info.last_name"
                        placeholder="Last Name"
                        label="Last Name"
                />  
                
              <fg-input
                        v-model="info.contact_number"
                        placeholder="Contact Number"
                        label="Contact Number"
                /> 

          </div>

      <div class="gluata-services">
         <label>if Gluta Services?</label>
         <input type="checkbox" v-if = "gluta_services == 1" checked value="true" v-model="gluta_services"  @change="getTimeList" /><input type="checkbox" v-else value="true"  @change="getTimeList" v-model="gluta_services"/> Yes
        
        </div>
      <label>Please Enter Date</label><br/>   
      <input type="date" v-model="info.date" v-on:change="changeDate" placeholder="Enter Date" />
      
      <div v-if="if_edit" id="time-of">Time of Appointment: <span>{{info.time}}</span>. <br/>If you want to change the time Please select the dropdown time</div>
      <select v-model="info.time" class="time-list">
        <option value="">Select Time</option>
        <option v-for="(item, index) in time_list"  :value="item">
          {{item}}
        </option>
      </select>

      

       <div class="w-full mt-4 p-10">
          <div v-for="(service, index) in services" :key="index">
            <div class="flex justify-start ml-2 mt-4">
              <input
                v-model="service.services_name"
                placeholder="Service"
                class="w-full py-2 border border-indigo-500 rounded"
              />
              <p-button type="info" round @click.native.prevent="remove(index)" class="trash-service"><span class="ti-trash"></span></p-button>
            </div>
          </div>
        </div>
        <p-button type="info" round @click.native.prevent="addMore()" class="add-services">Add Service</p-button>
       <div style="clear:both; height: 30px;"></div>
        <p v-show="show_status">
        <label>Status:</label><br/>
        <select v-model="info.status">
            <option value="Cancel">Cancel</option>
            <option value="Done">Done</option>
        </select>
       </p>
       <div class="form-group">
                  <label class="control-label">Select Branch</label><br/>
                  <select v-model="info.branch_id" class="branch-list">
                    <option disabled value="">Please select a branch</option>
                    <option value="1">Gaerlan</option>
                    <option value="2">Dolores (New)</option>
                  </select>
       </div>
       <div style="clear:both;">&nbsp;</div>
       <p-button type="info" round @click.native.prevent="addAppointment" id="add-appointment" v-show="btn_type == 'add'" v-if="add_btn">
            SAVE APPOINTMENT
       </p-button> 
       <p-button type="info" round @click.native.prevent="updateAppointment" id="add-appointment" v-show="btn_type == 'edit'">
            Update
       </p-button>  
       <div style="clear:both;">&nbsp;</div>
    </Modal>


    <Modal :showModal="modalViewVisible" :title="modal_title" @close="closeModalViewAppointment">
      <loader v-if="loader"/> 
      <div class="row">
          <div class="col-lg-12">
            <p class="appoint-info">Date: {{info.date}}</p>
            <p class="appoint-info">Time: {{info.time}}</p>
            <p class="appoint-info">Services: {{services}}</p>
            <p class="appoint-info">Branch: {{branch}}</p>
          </div>
      </div>
       <div style="clear:both;">&nbsp;</div>
       <p-button type="info" round @click.native.prevent="moveToClient()" class="edt-appointment" v-show="move_btn">
            Move to Client
       </p-button> 
       <p-button type="info" round @click.native.prevent="editEvent(info.id)" class="edt-appointment">
            Edit APPOINTMENT
       </p-button> 
       <div style="clear:both;">&nbsp;</div>
    </Modal>

  </div>
</template>
<script>
import api  from "@/static/config.json";
import axios from 'axios'
import Loader from "@/components/Loader";
import Modal from '@/components/Modal';
import Paginate from 'vuejs-paginate'
import DatePicker from 'vue2-datepicker';

import VAutocomplete from 'v-autocomplete';
import ItemTemplate from '@/components/ItemTemplate.vue';

import 'vue2-datepicker/index.css';
import 'v-autocomplete/dist/v-autocomplete.css';

import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'


export default {
  components:{
    Loader,
    Paginate,
    Modal,
    DatePicker,
    VAutocomplete,
    ItemTemplate,
    FullCalendar
  },
  data() {
    return {
      loader: false,
      loader_save: false,
      records: {
          success:true
      },
      total_page: 0,
      appointments:[],
      showAddModal:true,
      modalVisible: false,
      modalViewVisible:false,
      info:{
          id:'',
          first_name:'',
          last_name:'',
          contact_number:'',
          services:'',
          date:'',
          time:'',
          status:'',
          client_type:'',
          branch_id:''
      },
      search_value:'',
      from_value:'',
      to_value:'',
      modal_title:'',
      modal_button:'',
      btn_type:'',
      client_name:'',
      branch:'',
      services: [
        {
          services_name: "",
        },
      ],
      topay:false,
      show_status:false,
      view_existing:false,
      view_new:false,
      item: {},
      items: [],
      template: ItemTemplate,
      input_name:'',
      time_list:[],
      gluta_services: '',
      date_range:'',
      calendarOptions: {
        plugins: [dayGridPlugin],
        initialView: 'dayGridMonth',
        weekends: true,
        events: [],
        datesSet: this.handleMonthChange,
        eventClick: this.handleEventClick
      },
      select_view:'',
      calendar_list:false,
      view_list:false,
      if_edit:false,
      add_btn:true,
      move_btn:false,
      branches: [
        { id: 1, name: "Gaerlan" },
        { id: 2, name: "Dolores" },
      ],
    }
  },
  methods:{
    async list(page=1){
           let self = this;
           let limit=10;

           self.calendar_list = true;

           const range_data = this.date_range;

           if(this.date_range!=""){
               this.from_value = range_data[0].toLocaleDateString("en-US", { 
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
              })

               this.to_value = range_data[1].toLocaleDateString("en-US", { 
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
              })
           }
           

           let from = this.from_value == '' ? this.getDate() : this.from_value
           let to = this.to_value == '' ? this.getDate() : this.to_value

           self.page = page;
           self.loader = true;

                await axios.get(api.API_URL+`/appointment?page=${page}&limit=${limit}&from=${from}&to=${to}`,
                  {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                  }
                ).then(({data})=>{
                  self.loader = false;
                  self.appointments = data
                  self.total_page = Math.ceil(data.total/limit);

                }).catch(({ response })=>{
                  if(response.data.error.code =='token_could_not_verified'){
                              localStorage.removeItem("token");
                              this.$router.push('/login')
                  }

                })
     },

     clickCallback (pageNum){
        console.log(pageNum)
        this.list(pageNum)
    },
    openModalAppointment() {
      this.modalVisible = true;
    },
    closeModalAppointment() {
      this.modalVisible = false;
    },
    closeModalViewAppointment(){
      this.modalViewVisible = false;
    },
    addAppointment(){
      const token = localStorage.getItem('token');
      this.loader_save = true;
      let self = this;
      this.add_btn = false;
            axios.post(api.API_URL+'/appointment/store', {
                    first_name: self.info.first_name,
                    last_name: self.info.last_name,
                    contact_number: self.info.contact_number,
                    time: self.info.time,
                    date: self.info.date,
                    services:self.services,
                    gluta_services:self.gluta_services,
                    client_type:self.info.client_type,
                    branch_id:self.info.branch_id
                },
                
                {
                 headers: { Authorization: `Bearer ${token}`}
                }
                )
                    .then((data) => {
                      self.loader_save = false;
                      self.notifyVue('top', 'center','success','Appointment Successfully Added','ti-announcement')
                      self.list();
                      self.closeModalAppointment()
                      self.info.first_name = ''
                      self.info.last_name = ''
                      self.info.contact_number = ''
                      self.info.status = ''
                      self.info.date = ''
                      self.info.time = ''
                      self.services = []
                      self.handleMonthChange();
                      this.add_btn = true;
                    })
                    .catch((error) => {
                      try {
                           self.loader_save = false;
                          if(error.response.status==400){
                            this.notifyVue('top', 'center','danger',error.response.data.error.message,'ti-hand-stop')
                          }else if(error.response.status==422){
                            for (const [key, value] of Object.entries(error.response.data)) {
                                this.notifyVue('top', 'center','danger',value,'ti-hand-stop')
                            }
                            
                            this.add_btn = true;  
                          }
                        }
                        catch(err) {
                        
                        }
                    });

                    
    },
    updateAppointment(){
      const token = localStorage.getItem('token');
      this.loader_save = true;
      let self = this;
      let client_id = this.$route.params.id
      console.log(self.services)
            axios.put(api.API_URL+'/appointment/update/'+self.info.id, {
                   first_name: self.info.first_name,
                    last_name: self.info.last_name,
                    contact_number: self.info.contact_number,
                    time: self.info.time,
                    date: self.info.date,
                    services:self.services,
                    status: self.info.status,
                    gluta_services:self.gluta_services,
                    client_type:self.info.client_type,
                    branch_id:self.info.branch_id
                },
                
                {
                 headers: { Authorization: `Bearer ${token}`}
                }
                )
                    .then((data) => {
                      self.loader_save = false;
                      self.notifyVue('top', 'center','success','Appointment Successfully Updated','ti-announcement')
                      self.list();
                      self.closeModalAppointment()
                      self.info.first_name = ''
                      self.info.last_name = ''
                      self.info.contact_number = ''
                      self.handleMonthChange();
                    })
                    .catch((error) => {
                      try {
                           self.loader_save = false;
                          if(error.response.status==400){
                            alert(error.response.data.error.message)
                            this.notifyVue('top', 'center','danger',error.response.data.error.message,'ti-hand-stop')
                          }else if(error.response.status==422){
                            for (const [key, value] of Object.entries(error.response.data)) {
                                this.notifyVue('top', 'center','danger',value,'ti-hand-stop')
                            }
                            
                           
                          }
                        }
                        catch(err) {
                        
                        }
                    });
    },
    notifyVue(verticalAlign, horizontalAlign,type,msg,icon) {
      const color = Math.floor(Math.random() * 4 + 1);
      this.$notify({
        title:msg,
        icon: icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },
    search(){
        this.list()
    },
    modalAddAppointment(){
      this.info.first_name = ''
      this.info.last_name = ''
      this.info.contact_number = ''
      this.info.time = ''
      this.info.date = ''
      this.info.client_type = ''
      this.input_name = ''
      this.info.date = '';
      this.gluta_services = '';
      this.view_existing = false;
      this.info.time = '';
      this.modal_title = 'Add Appointment'
      this.modal_button = 'Add'
      this.openModalAppointment()
      this.btn_type = 'add'
      this.topay = false;
      this.add_btn = true;
      this.services = [{ services_name: "" }];
    },
    modalEditAppointment(appointment){
      this.if_edit = true;
      this.modal_title = 'Update Appointment'
      this.modal_button = 'Update'
      this.openModalAppointment()
      this.btn_type = 'edit'
      this.info.first_name = appointment.first_name
      this.info.last_name = appointment.last_name
      this.info.contact_number = appointment.contact_number
      this.info.time = appointment.time
      this.info.date = appointment.date
      this.info.status = appointment.status
      this.info.notes = appointment.notes
      this.info.total = appointment.total
      this.info.client_type = appointment.type
      this.gluta_services = appointment.gluta_services == 1 ? true : false
      this.info.client_id = appointment.client_id
      this.info.id = appointment.id
      const servicesData = JSON.parse(appointment.services);
      this.services = Array.isArray(servicesData) ? servicesData : [{ services_name: "" }];
      this.show_status = true;
      this.topay = true;
      this.info.cash = 0;
      this.info.change = 0;
      if(appointment.type=='new'){
            this.view_new = true;
            this.view_existing = false;
        }else if(appointment.type=='existing'){
            this.view_new = false;
            this.view_existing = true;
        }

      this.getTimeList()
    },
    deleteAppointment(id){
      const token = localStorage.getItem('token');
      this.loader_save = true;
      let self = this;

      const response = confirm("Are you sure you want to do delete?");

                if (response) {
                  axios.delete(api.API_URL+'/appointment/delete/'+id,
                
                {
                 headers: { Authorization: `Bearer ${token}`}
                }
                )
                    .then((data) => {
                      self.loader_save = false;
                      self.notifyVue('top', 'center','success','Appointment Successfully Deleted','ti-announcement')
                      self.list();
                    })
                    .catch((error) => {
                      try {
                           self.loader_save = false;
                          if(error.response.status==400){
                            alert(error.response.data.error.message)
                            this.notifyVue('top', 'center','danger',error.response.data.error.message,'ti-hand-stop')
                          }else if(error.response.status==422){
                            for (const [key, value] of Object.entries(error.response.data)) {
                                this.notifyVue('top', 'center','danger',value,'ti-hand-stop')
                            }
                            
                           
                          }
                        }
                        catch(err) {
                        
                        }
                    });
                } else {
                   
                }

    },
    addMore() {
      this.services.push({
        services_name: ""
      });
    },
    remove(index) {
      this.services.splice(index, 1);
      this.price(); 
    },
    getDate(){
      const today = new Date();
      const yyyy = today.getFullYear();
      let mm = today.getMonth() + 1; // Months start at 0!
      let dd = today.getDate();

      if (dd < 10) dd = '0' + dd;
      if (mm < 10) mm = '0' + mm;

      const formattedToday = mm + '/' + dd + '/' + yyyy;
      return formattedToday;
    },
    getTime(){
      const today = new Date();
      const formattedTime = today.toLocaleTimeString().replace(/:\d+ /, ' ');
      return formattedTime;
    },
    price: function () {
          let total = 0;
          var p = this.services;
          for (var key in p) {
              if (p.hasOwnProperty(key)) {
                  total = total + parseInt(p[key].price);
                  
              }
          }

          this.info.total = total
    },
    isNumber(value) {
        return typeof value === 'number';
    },
    format_price: function(newValue) {
      const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return result;
    },
    cash: function(e){
        const change = parseInt(this.info.cash) - parseInt(this.info.total);
        this.info.change = change;
    },
    selectClient(event){
        if(event.target.value=='new'){
            this.view_new = true;
            this.view_existing = false;
        }else if(event.target.value=='existing'){
            this.view_new = false;
            this.view_existing = true;
        }
    },
    getLabel (item) {   
      this.info.first_name = item.first_name
      this.info.last_name = item.last_name
      this.info.contact_number = item.contact_number

      return item.first_name + ' ' + item.last_name
    },
    updateItems (text) {
      let self = this;
      self.loader_save = true;

               axios.get(api.API_URL+`/client?search=${text}`,
                  {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                  }
                ).then(({data})=>{
                  self.loader_save = false;
                  self.items = data.data

                }).catch(({ response })=>{
                      if(response.data.error.code =='token_could_not_verified'){
                          this.$router.push('/login')
                      }
                })
    },
    getTimeList () {
                let self = this;
                let date = this.info.date;
                let gluta_services = this.gluta_services;


                axios.get(api.API_URL+`/generate-time?date=${date}&gluta_services=${gluta_services}`,
                  {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                  }
                ).then(({data})=>{
                  self.time_list = data

                }).catch(({ response })=>{
                      if(response.data.error.code =='token_could_not_verified'){
                          this.$router.push('/login')
                      }
                })
    },changeDate(){
        this.getTimeList();
    },generate(){
        this.list()
        this.calendar_list = false;
        this.view_list = true;
    },
    SelectView(){

      if(this.select_view=='calendar'){
          this.calendar_list = true;
          this.view_list = false;
      }else{
          this.calendar_list = false;
          this.view_list = true;
      }

    },
    async handleMonthChange() {
      let self = this;
      let calendarApi = this.$refs.cc.getApi();
      let current_month = calendarApi.view.currentStart;
      let month_year = current_month.toLocaleDateString("en-US", { 
                year: "numeric",
                month: "2-digit"
              })
      self.loader = true;        
             axios.get(api.API_URL+`/appointment/calendar?filter=${month_year}`,
                  {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                  }
                ).then(({data})=>{
                  self.loader = false;
                    const eventData = data
                    this.calendarOptions.events = eventData
                    this.$refs.calendar.getApi().render() 

                }).catch(({ response })=>{
                  
                })         


    },
    handleEventClick(info) {
      // info.event.id

      this.modal_title = 'View Appointment'
      this.modalViewVisible = true;

      self = this;
      self.loader = true;
      this.modal_title = 'View Appointment'
      this.info.date = ''
      this.info.time = ''
      this.services = ''
      this.branch = ''

      axios.get(api.API_URL+`/appointment/show/${info.event.id}`,
                  {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                  }
                ).then(({data})=>{
                  self.loader = false
                  if(data.client_exist==1){
                    self.move_btn = false
                  }else{
                    self.move_btn = true
                  }
                  self.modal_title = data.first_name + ' ' + data.last_name;
                  self.info.first_name = data.first_name;
                  self.info.last_name = data.last_name;
                  self.info.contact_number = data.contact_number;
                  self.info.id =  info.event.id
                  self.info.branch_id =  data.branch_id
                  self.branch =  data.branch_id == 1 ? "Gaerlan" : "Dolores"
                  const date = new Date(data.date); // {object Date}        
                  self.info.date = date.toLocaleDateString("en-US", { 
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                          })
                  self.info.time = data.time
                  self.services = JSON.parse(data.services).map(function(val) {
                    return val.services_name;
                  }).join(',');

                }).catch(({ response })=>{
                      if(response.data.error.code =='token_could_not_verified'){
                          this.$router.push('/login')
                      }
                })


     
    },editEvent(event_id){
      
      self = this;
      self.loader = true;
      this.modalViewVisible = false;

      axios.get(api.API_URL+`/appointment/show/${event_id}`,
                  {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                  }
                ).then(({data})=>{
                  self.loader = false
                  self.if_edit = true
                  self.modal_title = 'Update Appointment'
                  self.btn_type = 'edit'
                  self.modal_button = 'Update'
                  self.openModalAppointment()
                  self.data = 'edit'
                  if(data.type=='new'){
                    self.view_new = true;
                    self.view_existing = false;
                  }else if(data.type=='existing'){
                    self.view_new = false;
                    self.view_existing = true;
                  }

                  self.info.first_name = data.first_name
                  self.info.last_name = data.last_name
                  self.info.contact_number = data.contact_number
                  self.info.time = data.time
                  self.info.date = data.date
                  self.info.status = data.status
                  self.info.notes = data.notes
                  self.info.total = data.total
                  self.info.client_type = data.type
                  self.gluta_services = data.gluta_services == 1 ? true : false
                  self.info.client_id = data.client_id
                  self.info.id = data.id
                  self.services = JSON.parse(data.services)
                  self.show_status = true;
                  self.getTimeList()

                }).catch(({ response })=>{
                      if(response.data.error.code =='token_could_not_verified'){
                          this.$router.push('/login')
                      }
                })
    },
    moveToClient(){
      const token = localStorage.getItem('token');
      this.loader = true;
      let self = this;
      this.move_btn = false;
            axios.post(api.API_URL+'/client/store', {
                    first_name: self.info.first_name,
                    last_name: self.info.last_name,
                    contact_number: self.info.contact_number,
                },
                
                {
                 headers: { Authorization: `Bearer ${token}`}
                }
                )
                    .then((data) => {
                      self.loader = false;
                      self.notifyVue('top', 'center','success','Client Successfully Added','ti-announcement')
                      self.move_btn = false;
                    })
                    .catch((error) => {
                      try {
                           self.loader = false;
                          if(error.response.status==400){
                            alert(error.response.data.error.message)
                            this.notifyVue('top', 'center','danger',error.response.data.error.message,'ti-hand-stop')
                          }else if(error.response.status==422){
                            for (const [key, value] of Object.entries(error.response.data)) {
                                this.notifyVue('top', 'center','danger',value,'ti-hand-stop')
                            }
                            
                            this.move_btn = false;  
                           
                          }
                        }
                        catch(err) {
                        
                        }
                    });
    },
    moveListToClient(appointment){
      const token = localStorage.getItem('token');
      this.loader = true;
      let self = this;
      this.move_btn = false;
            axios.post(api.API_URL+'/client/store', {
                    first_name: appointment.first_name,
                    last_name: appointment.last_name,
                    contact_number: appointment.contact_number,
                },
                
                {
                 headers: { Authorization: `Bearer ${token}`}
                }
                )
                    .then((data) => {
                      self.loader = false;
                      self.notifyVue('top', 'center','success','Client Successfully Added','ti-announcement')
                      self.move_btn = false;
                    })
                    .catch((error) => {
                      try {
                           self.loader = false;
                          if(error.response.status==400){
                            alert(error.response.data.error.message)
                            this.notifyVue('top', 'center','danger',error.response.data.error.message,'ti-hand-stop')
                          }else if(error.response.status==422){
                            for (const [key, value] of Object.entries(error.response.data)) {
                                this.notifyVue('top', 'center','danger',value,'ti-hand-stop')
                            }
                            
                            this.move_btn = false;  
                           
                          }
                        }
                        catch(err) {
                        
                        }
                    });
    },
  },
  created() {
      this.list();
      this.client_name = localStorage.getItem('client_name');
      this.info.client_id = this.$route.params.id;
      console.log(new Date('2/6//2024 10:30 AM'))
      
  }
};
</script>
<style>
#appointment-tbl .btn{padding: 5px 10px!important; margin-right:5px;}
.action{text-align: center;}
#top-tool-bar{padding:10px;}
#add-appointment{float:right;}
#search{width:50%;}
.pagination li{margin-right:20px;}
.pagination{padding: 10px!important;}
.pagination .page-item.active a{font-weight: bold; background-color: #b6aa62!important;} 
.pagination li a{background: #028f8f; padding: 5px; color: #fff!important; }
#add-appointment{float:right;}
#no-record{font-weight: bold; font-size: 20px;}
.client-name{margin-left: 10px;}
.modal{overflow-y: scroll!important;}
.trash-service{margin-left: 10px;}
#grand-total{float:right;}
.add-services{margin-top:30px;}
.cash-label{font-weight: bold; font-size: 22px; margin-right: 10px;}
#client-notes{width:100%;}
.select-client{display: block; margin-bottom: 20px; width:128px;}
.back-home{margin-bottom: 20px; background: #028f8f; color:#fff; border:none;}
.v-autocomplete-list{z-index: 9999; background-color: #fff; position: absolute; border:1px solid #000; }
.autocomplete{margin-bottom: 30px;}
.v-autocomplete-list-item{padding-bottom: 5px; border:1px solid #000; padding: 10px;}
.time-list{display: block; margin-top: 20px; width: 128px;}
.gluata-services{margin-top:20px; margin-bottom:20px;}
.gluata-services label{display: block; font-weight: bold; font-size: 16px;}
#fullcalendar{padding: 10px;}
#select-view{padding:6px; margin-right: 20px;}
#time-of{font-weight: bold; margin-top: 25px;}
#time-of span{color: red;}
#top-tool-bar .mx-datepicker-range{width: 220px; margin-right: 15px;}
a.fc-event{cursor: pointer;}
.appoint-info{font-size: 20px; font-weight: bold;}
.edt-appointment{margin-right: 5px;}
#addAppointmentForm .modal{height: 500px!important;}
</style>
